// 由 EB view/admin/src/router/modules/user.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const userRouter: RouteRecordRaw =
  {
    path: `${roterPre}/user`,
    name: 'user',
    meta: {
      title: '用户管理'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'group',
        component: () => import('@/views/user/group/index.vue'),
        name: 'UserGroup',
        meta: { title: '用户分组', noCache: true }
      },
      {
        path: 'label',
        component: () => import('@/views/user/group/index.vue'),
        name: 'UserLabel',
        meta: { title: '用户标签', noCache: true }
      },
      {
        path: 'list',
        component: () => import('@/views/user/list/index.vue'),
        name: 'UserList',
        meta: { title: '用户列表', noCache: true }
      },
      {
        path: 'searchRecord',
        component: () => import('@/views/user/search/index.vue'),
        name: 'searchRecord',
        meta: { title: '用户搜索记录', noCache: true }
      },
      {
        path: 'agreement',
        component: () => import('@/views/user/agreement/index.vue'),
        name: 'UserAgreement',
        meta: { title: '协议与隐私政策', noCache: true }
      },
      {
        path: 'setup_user',
        name: 'Setup_user',
        meta: {
          title: '用户设置',
          noCache: true
        },
        component: () => import('@/views/user/setupUser/index.vue')
      },
      // TITA 扩展：invite_quota / safety_report 已迁至 router/modules/expand/social.ts
      {
        path: 'member',
        name: 'Member',
        meta: {
          title: '会员',
          noCache: true
        },
        redirect: 'noRedirect',
        component: () => import('@/views/user/member/index.vue'),
        children: [
          {
            path: 'config',
            name: 'memberConfig',
            meta: {
              title: '会员配置',
              noCache: true
            },
            component: () => import('@/views/user/member/config.vue')
          },
          {
            path: 'list',
            name: 'memberList',
            meta: {
              title: '会员管理',
              noCache: true
            },
            component: () => import('@/views/user/member/list.vue')
          },
          {
            path: 'interests',
            name: 'memberInterests',
            meta: {
              title: '等级会员权益',
              noCache: true
            },
            component: () => import('@/views/user/member/interests.vue')
          },
          {
            path: 'equity',
            name: 'memberEquity',
            meta: {
              title: '会员权益',
              noCache: true
            },
            component: () => import('@/views/user/member/equity.vue')
          },
          {
            path: 'description',
            name: 'memberDescription',
            meta: {
              title: '用户等级说明',
              noCache: true
            },
            component: () => import('@/views/user/member/description.vue')
          },
          {
            path: 'vipAgreement',
            name: 'vipAgreement',
            meta: {
              title: '会员协议',
              noCache: true
            },
            component: () => import('@/views/user/member/vipAgreement.vue')
          },
          {
            path: 'type',
            name: 'vipType',
            meta: {
              title: '会员类型',
              noCache: true
            },
            component: () => import('@/views/user/member/type.vue')
          },
          {
            path: 'record',
            name: 'vipRecord',
            meta: {
              title: '会员记录',
              noCache: true
            },
            component: () => import('@/views/user/member/record.vue')
          },

        ]
      },
    ]
  }

export default userRouter;
